module.exports = __webpack_public_path__ + "img/f_2.cff9388.png";